// polyfills
import 'promise-polyfill/src/polyfill';
import 'unfetch/polyfill';

// packages
import { apdate, aptime, intcomma } from 'journalize';
import { utcToZonedTime } from 'date-fns-tz/esm';
import mapboxgl from 'mapbox-gl';
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.min.js';

// local
import {
  MAPBOX_GL_TOKEN,
  MONITORED_URL,
  OUTAGES_URL,
  SUMMARY_URL,
} from './constants';

const FIVE_MINUTES = 1000 * 60 * 5;

const totalCustomersAffectedEl = document.querySelector('#total-affected');
const timestampEl = document.querySelector('#timestamp');

const mobileMatchMedia = window.matchMedia('(min-width: 34em)');

mapboxgl.accessToken = MAPBOX_GL_TOKEN;

const map = new mapboxgl.Map({
  container: 'map',
  style: 'mapbox://styles/mapbox/light-v10',
  bounds: [-123.654827, 37.73145, -120.092231, 40.940714],
  fitBoundsOptions: {
    padding: {
      top: mobileMatchMedia.matches ? 20 : 60,
      bottom: 20,
      left: 20,
      right: 20,
    },
  },
  minZoom: 0,
  maxZoom: 15,
});

const geocoder = new MapboxGeocoder({
  accessToken: MAPBOX_GL_TOKEN,
  mapboxgl,
  marker: false,
  // placeholder: 'Submit your address to zoom map',
  country: 'us',
  bbox: [
    -125.35400390624999,
    31.970803930433096,
    -113.26904296874999,
    42.53689200787315,
  ],
});

// document.getElementById('geocoder').appendChild(geocoder.onAdd(map));
map.addControl(geocoder);

const nav = new mapboxgl.NavigationControl({ showCompass: false });

map.addControl(nav);

map.on('load', async () => {
  const layers = map.getStyle().layers;

  // Find the index of the first symbol layer in the map style
  let firstSymbolId;

  for (let i = 0; i < layers.length; i++) {
    if (layers[i].type === 'symbol') {
      firstSymbolId = layers[i].id;
      break;
    }
  }

  map.addSource('monitored', {
    type: 'geojson',
    data: MONITORED_URL,
  });

  map.addLayer(
    {
      id: 'monitored-layer',
      type: 'fill',
      source: 'monitored',
      paint: {
        'fill-color': '#ec862b',
        'fill-opacity': 0.6,
      },
    },
    firstSymbolId
  );

  map.addSource('outages', {
    type: 'geojson',
    data: OUTAGES_URL,
  });

  map.addLayer(
    {
      id: 'psps-polygons-layer',
      type: 'fill',
      source: 'outages',
      paint: {
        'fill-color': '#8f261e',
        'fill-opacity': 0.6,
      },
      filter: ['==', '$type', 'Polygon'],
    },
    firstSymbolId
  );

  map.addLayer(
    {
      id: 'psps-points-layer',
      type: 'circle',
      source: 'outages',
      paint: {
        'circle-color': '#8f261e',
        // make circles larger as the user zooms from z12 to z22
        'circle-radius': {
          base: 1.75,
          stops: [
            [8, 2],
            [15, 80],
          ],
        },
        'circle-opacity': 0.6,
      },
      filter: ['==', '$type', 'Point'],
    },
    firstSymbolId
  );

  // update the map every five minutes
  window.setInterval(() => {
    map.getSource('monitored').setData(MONITORED_URL);
    map.getSource('outages').setData(OUTAGES_URL);
  }, FIVE_MINUTES);
});

function updateSummary() {
  fetch(SUMMARY_URL)
    .then(res => res.json())
    .then(({ lastUpdated, estimatedCustomersAffected }) => {
      const d = utcToZonedTime(new Date(lastUpdated), 'America/Los_Angeles');
      const month = apdate(d).split(',')[0];
      const time = aptime(d);

      totalCustomersAffectedEl.textContent = intcomma(
        estimatedCustomersAffected
      );
      timestampEl.textContent = `${month}, ${time} PT`;
    });
}

window.setInterval(() => {
  updateSummary();
}, FIVE_MINUTES);

updateSummary();
